import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../store";
import { api } from "@/utils/api";

export interface MeasurementParameterUnit {
  id: number;
  name: string;
}

export interface TypeWithUnits {
  id: number;
  name: string;
  swmmParameter: string | null;
  description: string | null;
  units: MeasurementParameterUnit[];
}

interface TypesWithUnitsState {
  fetching: boolean;
  array: TypeWithUnits[];
  error?: string;
}

const initialState: TypesWithUnitsState = {
  fetching: false,
  array: [],
};

const typesWithUnitsSlice = createSlice({
  name: "typesWithUnits",
  initialState,
  reducers: {
    getTypesWithUnits(state) {
      state.fetching = true;
    },
    getTypesWithUnitsSuccess(state, action: PayloadAction<TypeWithUnits[]>) {
      state.fetching = false;
      state.array = action.payload;
    },
    getTypesWithUnitsError(state, action: PayloadAction<string>) {
      state.fetching = false;
      state.error = action.payload;
    },
  },
});

export const {
  getTypesWithUnits,
  getTypesWithUnitsSuccess,
  getTypesWithUnitsError,
} = typesWithUnitsSlice.actions;
export default typesWithUnitsSlice.reducer;

export const getTypesWithUnitsAction = () => async (dispatch: AppDispatch) => {
  dispatch(getTypesWithUnits());
  try {
    const res = await api.get(
      `${import.meta.env.VITE_APP_BASE_URL}/measurements/types/units`
    );
    dispatch(getTypesWithUnitsSuccess(res.data));
  } catch (err: any) {
    console.error(err);
    dispatch(
      getTypesWithUnitsError(err.response?.message || "Error desconocido")
    );
  }
};

export const selectUnitsByTypeId = (
  typesWithUnits: TypeWithUnits[],
  typeId: number
): MeasurementParameterUnit[] => {
  const type = typesWithUnits.find((t) => t.id === typeId);
  return type?.units ?? [];
};
